<div class="preview-image">
    <mat-icon class="modal__close-icon" (click)="closeDialog()">close</mat-icon>
    <img [src]="src" alt="" class="preview-image__image">
    <button class="button-base button-base__primary-black button-base__lg preview-image__button" (click)="closeDialog()">
        Volver
    </button>
</div>